import {
  TableDetails,
  TableHandHistoryPayload,
  TableLiveResults,
  TableSummary,
  TableForceRemovePlayerResult,
} from '../types';
import { apiRequest } from './apiClient';

interface TableListResponse {
  success: boolean;
  data: TableSummary[];
}

interface TableDetailsResponse {
  success: boolean;
  data: TableDetails;
}

interface TableLiveResultsResponse {
  success: boolean;
  data: TableLiveResults;
}

interface TableHandHistoryResponse {
  success: boolean;
  data: TableHandHistoryPayload;
}

export const tableService = {
  async getClubTables(clubId: string): Promise<TableSummary[]> {
    const payload = await apiRequest<TableListResponse>(`/clubs/${clubId}/tables`);
    return Array.isArray(payload.data) ? payload.data : [];
  },

  async getTable(tableId: string): Promise<TableDetails> {
    const payload = await apiRequest<TableDetailsResponse>(`/tables/${tableId}`);
    return payload.data;
  },

  async getLiveResults(tableId: string): Promise<TableLiveResults> {
    const payload = await apiRequest<TableLiveResultsResponse>(`/tables/${tableId}/live-results`);
    return payload.data;
  },

  async getHandHistory(
    tableId: string,
    options?: { limit?: number; offset?: number }
  ): Promise<TableHandHistoryPayload> {
    const params = new URLSearchParams();
    if (typeof options?.limit === 'number') {
      params.set('limit', String(options.limit));
    }
    if (typeof options?.offset === 'number') {
      params.set('offset', String(options.offset));
    }

    const suffix = params.toString() ? `?${params.toString()}` : '';
    const payload = await apiRequest<TableHandHistoryResponse>(`/tables/${tableId}/hand-history${suffix}`);
    return payload.data;
  },

  async removePlayerFromTable(tableId: string, userId: string): Promise<TableForceRemovePlayerResult['data']> {
    const payload = await apiRequest<TableForceRemovePlayerResult>(`/tables/${tableId}/players/${userId}/remove`, {
      method: 'POST',
    });
    return payload.data;
  },
};
